import ListingTypeBox from '@app/components/ListingTypeBox'
import { IListing } from '@app/models/Listing'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import { Link } from 'react-router-dom'

export interface IListingResultItemProps {
  item: IListing
}

export class ListingResultItem extends React.PureComponent<
  IListingResultItemProps
> {
  public render() {
    return (
      <Link
        to={`/brokerage/listing/${this.props.item.id}`}
        className='result-item'
      >
        <div className='align-self-center'>
          <ListingTypeBox
            className='mr-2'
            status={this.props.item.status}
            type={this.props.item.type}
          />
        </div>
        <div className='flex-grow-1'>
          <div className='font-weight-bold'>{this.props.item.title}</div>
          <div className='small'>
            {formatAddressSingleLine(
              this.props.item.associatedProperty.address,
            )}
          </div>
        </div>
      </Link>
    )
  }
}
